import GameCodeFrame from "./game-code-frame"
import UsernamePage from "./username-frame"
import MemeFrame from "./meme-frame"
import StudentLeaderboard from "./leaderboard-frame"
import LobbyFrame from "./lobby-frame"
import LoadingPage from "./loading-frame"
import FinalScreenFrame from "./final-screen-frame"
import { PropsWithChildren } from "react"
import { usePlayState } from "play/hooks/use-play-state"

export default function Frame(props: PropsWithChildren<{}>) {
  const { children } = props
  const { internalPage } = usePlayState()

  // console.log({internalPage})

  switch (internalPage) {
    case "GameCode":
      return <GameCodeFrame />

    case "UserName":
      return <UsernamePage />

    case "ShowMeme":
      return <MemeFrame />

    case "StudentLeaderboard":
      return <StudentLeaderboard />

    case "PageNotFound":
      return null //<NotFoundPage/>

    case "Lobby":
      return <LobbyFrame />

    case "Loading":
      return <LoadingPage />

    case "FinalScreen":
      return <FinalScreenFrame />
  }

  return <>{children}</>
}
